<template>
    <div class="DistributionPrice">
        分销价：
        <!-- <span style="color: #ff0000; font-size: 12px; position: relative; bottom: 0px; right:4px;" v-if="price !== -1 && price!==null">￥</span> -->
        <span :class="[price !== -1 ? 'big-font' : '', disToSupDetail ? 'dis-to-sup-price' : '', 'DistributionPrice_price']">
            <span v-if="price === -1">合作后查看</span>
            <AmountDigitText v-else :value="price" :precision="2"/>
        </span>
        <!-- <span style="color: #ff0000; font-size: 12px; position: relative; bottom: 0px; left:4px" v-if="price !== -1 &&  price!==null"> 起</span> -->
        <el-popover
            v-if="!disToSupDetail"
            placement="top"
            width="350"
            trigger="hover">
            <p>
                分销价默认显示为未合作分销价<br>
                已合作分销商扫码后将看到合作后的分销价<br>
                <br>
                若要调整分销价，可去【分销商管理-分销价管理】<el-link :href="linkUrl" target="_blank">设置</el-link>
            </p>
            <i slot="reference" class="el-icon-bangzhuzhongxin DistributionPrice_help" />
        </el-popover>
    </div>
</template>

<script>
export default {
    name: 'DistributionPrice',
    props: {
        disToSupDetail: {
          type: Boolean,
          default: false
        },
        price: {
            type: Number,
            default: -1
        },
        precision: Number,
    },
    computed: {
        linkUrl() {
            return '/supplier/management/price'
        }
    }
}
</script>

<style lang="scss" scoped>
.DistributionPrice {
    // height: 40px;
    display: flex;
    align-items: center;
    .DistributionPrice_price {
        font-size: 1.1em;
        line-height: 1.1em;
        font-weight: bold;
        color:#FD8944;
        &.big-font {
            font-size: 18px;
            line-height: 1.4em;
        }
      &.dis-to-sup-price {
        color: #ff0000;
      }
    }
    .DistributionPrice_help {
        margin-left: 5px;
        vertical-align: baseline;
        font-size: 1.1em;
        color: #aaa;
    }
}
</style>